module.exports = __webpack_public_path__ + "static/media/loginImage.86b7ee78.png";